// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3O2LR","label":"Completed_label__1glL-"};